// Relacionamento Familiar
export const textoEspec1 = 'Conflitos e tensões familiares estão presentes no dia a dia e nem sempre é fácil de lidar, mesmo sendo “família”, o que alastra no seu bem-estar mental.';

// Relacionamento Amoroso
export const textoEspec2 = 'Saber administrar seu envolvimento e sentimentos quanto as outras pessoas - Lidar com inveja, ciúmes, controle e opiniões.'

// Autoestima e autoconfiança
export const textoEspec3 = 'Construir uma ótica mais positiva de si.'

// Transtornos e Gerenciamento de Emoções
export const textoEspec4 = 'Enfrentamento e ajudar para lidar com situações emocionais desafiadoras de forma mais tranquila.'

// Ansiedade (Pânico, Fobias e TOC)
export const textoEspec5 = 'Preocupações e responsabilidades que geram nervosismo, medo e inquietação, sendo uma preocupação constante do futuro. Podendo virar Fobias e outros Transtornos.'

// Estresse, Depressão e Humor
export const textoEspec6 = 'Desgaste, fadiga e traumas somados à exaustão mental e física desencadeiam transtornos psicológicos como Pânico, Sexual e Alimentar.'

// Terapia Personalizado
export const textoEspec7 = 'Adaptamos nossa abordagem terapêutica às suas necessidades individuais, fornecendo orientação e suporte personalizados.'

// Acolhimento Profissional
export const textoEspec8 = 'Oferecemos um espaço seguro e confidencial para você expressar suas preocupações e desafios emocionais.'

// Apoio Contínuo
export const textoEspec9 = 'Além das sessões regulares, estamos disponíveis para oferecer suporte adicional entre as consultas, garantindo que você tenha o apoio necessário ao longo do processo terapêutico.'

// Facilidade e Flexibilidade
export const textoEspec10 = 'Nosso serviço de psicologia clínica online oferece horários flexíveis para atender às suas necessidades, mesmo em horários não convencionais.'

// Bem-estar Integral
export const textoEspec11 = 'Trabalhamos não apenas para aliviar sintomas, mas também para promover um estado de bem-estar emocional, mental e psicológico duradouro!'

// Tratamento Comprovado
export const textoEspec12 = 'Temos um histórico comprovado de sucesso com nosso tratamento, ajudando inúmeras pessoas a superarem seus desafios emocionais.'